import React, { useState } from "react"
import MosaicItem from "../components/MosaicItem"
import * as styles from "../styles/mosaic.module.css"
import { graphql, useStaticQuery } from "gatsby"
import ReactImageVideoLightbox from '../../node_modules/react-image-video-lightbox/lib/index';


function Mosaic(props) {
  //const goToSlideWork = props.goToSlideWork;

  const data = useStaticQuery(graphql`
    query WorksData {
      allWorksDataJson {
        nodes {
          description
          id
          title
          url
          onMosaic
          logo {
            childImageSharp {
              gatsbyImageData(placeholder: NONE, formats: WEBP)
            }
          }
        }
      }
    }
  `)

  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxOpenUrl, setLightboxOpenUrl] = useState('');
  const [lightboxOpenTitle, setLightboxOpenTitle] = useState('');

  return (
    <>
      <div className={styles.item__container}>
        {data.allWorksDataJson.nodes.filter(data => data.onMosaic).map(data => {
          return (
            <MosaicItem
              setLightboxOpenUrl={setLightboxOpenUrl}
              setLightboxOpenTitle={setLightboxOpenTitle}
              setLightboxOpen={setLightboxOpen}
              data={data}
              key={data.id} />
          )
        })}
      </div>

      <div className={styles.lightbox}>
        {lightboxOpen && < ReactImageVideoLightbox
          data={
            [
              {
                url: `${lightboxOpenUrl}`,
                type: "video",
                altTag: `${lightboxOpenTitle}`,
                title: `${lightboxOpenTitle}`,
              }
            ]}
          startIndex={0}
          onCloseCallback={() => setLightboxOpen(false)}
        />
        }
      </div>
    </>
  )
}

export default Mosaic
